"use client";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axios";

export const fetchBannerDetailsByLink = createAsyncThunk(
  "bannerDetails/fetchBannerDetailsByLink",
  async ({ link, locale = "en" }) => {
    const queryString = `treatment-banners?populate=*&locale=${locale}&filters[link]=${link}`;
    const response = await axios.get(queryString);
    return response.data;
  },
);

const initialState = {
  bannerDetails: null,
  status: "idle",
  error: null,
};

const bannerDetailsSlice = createSlice({
  name: "bannerDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBannerDetailsByLink.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBannerDetailsByLink.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.bannerDetails = action.payload;
      })
      .addCase(fetchBannerDetailsByLink.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default bannerDetailsSlice.reducer;

export const selectBannerDetails = (state) => state.bannerDetails.bannerDetails;
